import Input from 'components/molecules/Input';
import { LinkTemplateConfig as LinkTemplateConfigType } from 'utils/gloo-types';

interface LinkTemplateConfigProps {
  template?: any;
  handleChange: (data: any) => void;
  handleForm: (data: any) => void;
}
function LinkTemplateConfig({ template, handleChange, handleForm }: LinkTemplateConfigProps) {
  const templateConfig = template.config as LinkTemplateConfigType;

  const updateConfigProperty = (key, value) => {
    handleChange((prevState) => {
      const config = prevState.config || {};
      config[key] = value;

      return {
        ...prevState,
        config,
      };
    });

    handleForm((prevState) => {
      const config = prevState.config || {};
      config[key] = value;

      return {
        ...prevState,
        config,
      };
    });
  };

  return (
    <>
      <Input
        label="Link (URL)"
        className="my-2"
        value={templateConfig?.url}
        onChangeText={(t) => {
          updateConfigProperty('url', t);
        }}
        required
      />
    </>
  );
}

export default LinkTemplateConfig;
